$(function(){  
  $(document).on('click', 'a.has_fee_remove', function(event){    
    event.preventDefault();

    var fee_quantity = 0;
    var new_qty = 0;

    // Get hidden remove item link
    var next_el_a = $(this).next('a.has_fee_linked');
    // Get current Fee quantity
    if ($('span#fee-quantity').length > 0) {
      fee_quantity = parseInt($('span#fee-quantity').html());
      // Adjust Fee quantity
      new_qty = fee_quantity - 4;
      console.log('fee_quantity', fee_quantity);  
    }

    // Call ajax to update cart and adjust Fee cart item quantity
    jQuery.post('/cart/update.js', {
      updates: {
        31566891221065: new_qty,
      }
    });

    // Simulate click on hidden remove item link
    // it will delete the associated item
    next_el_a.click();

    return false;
  });
});